import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { Company } from '@models/company/company';
import { ProExperience } from '@models/profile/pro-experience';
import { Store } from '@ngxs/store';
import { GetCompany } from '@store/company/company.actions';
import { CompanyState } from '@store/company/company.state';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: { year: 'numeric', month: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Component({
  selector: 'profile-pro-experience',
  templateUrl: './pro-experience.component.html',
  styleUrls: ['./pro-experience.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProExperienceComponent implements OnChanges {
  @Input() model: ProExperience;
  @Input() loading: boolean;
  company$: Observable<Company>;

  readingCommandsAlignment$: Observable<'top' | 'middle'>;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly store: Store,
    @Inject(PLATFORM_ID) readonly platformId: Record<string, unknown>
  ) {
    if (isPlatformBrowser(platformId)) {
      this.readingCommandsAlignment$ = this.breakpointObserver
        .observe('(min-width: 75em)') // = `xl` breakpoint
        .pipe(
          map((result) => result.matches),
          map((matches) => (matches ? 'top' : 'middle'))
        );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model && changes.model.currentValue && changes.model.currentValue.companyId) {
      this.store
        .dispatch(new GetCompany(changes.model.currentValue.companyId))
        .pipe(take(1))
        .subscribe((_) => {
          this.company$ = this.store.select(CompanyState.company(changes.model.currentValue.companyId));
        });
    }
  }
}
